import { useEffect, useRef } from "react";
import type { RowState } from "../daily-entry.types";
import { saveDraftSnapshot } from "../draft-storage";

const AUTOSAVE_INTERVAL_MS = 10_000;

/** Local-only autosave every ~10s while there are unsaved changes (§9). */
export function useDraftAutosave(
  workerId: string | null,
  workDate: string | null,
  rows: RowState[],
  hasUnsavedChanges: boolean,
) {
  const rowsRef = useRef(rows);
  rowsRef.current = rows;

  useEffect(() => {
    if (!workerId || !workDate) return;
    const interval = setInterval(() => {
      if (hasUnsavedChanges) {
        saveDraftSnapshot(workerId, workDate, rowsRef.current);
      }
    }, AUTOSAVE_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [workerId, workDate, hasUnsavedChanges]);
}
